(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const status = document.getElementById('status');
  const cartDialog = document.getElementById('cart-drawer');
  const cartContent = document.getElementById('cart-content');
  const notice = document.getElementById('cart-notice');
  let lastFocus;
  let noticeFocus;
  let cartBusy = false;
  function say(message) { if (status) status.textContent = message; }
  function openDialog(dialog) { lastFocus = document.activeElement; dialog.showModal(); }
  function closeDialog(dialog) { dialog.close(); }
  document.querySelectorAll('dialog').forEach(dialog => {
    if (!dialog.querySelector('[data-close]')) return;
    dialog.addEventListener('close', () => { lastFocus?.focus(); });
    dialog.querySelector('[data-close]')?.addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom) closeDialog(dialog);
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-search]')) return;
    if (!document.getElementById('search-dialog')?.showModal) return;
    e.preventDefault();
    openDialog(document.getElementById('search-dialog'));
    document.getElementById('search-input').focus();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') {
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => el.open = false);
    closeNotice();
  }});
  // Drop-down card under the header after Add to cart
  function closeNotice() {
    if (!notice?.classList.contains('is-active')) return;
    notice.classList.remove('is-active');
    if (notice.contains(document.activeElement)) noticeFocus?.focus({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    if (!notice?.classList.contains('is-active')) return;
    if (e.target.closest('[data-cart-notice-close]') || !notice.contains(e.target)) closeNotice();
  });
  document.querySelectorAll('.nav-dropdown').forEach(dropdown => dropdown.addEventListener('toggle', () => {
    if (dropdown.open) document.querySelectorAll('.nav-dropdown').forEach(other => { if (other !== dropdown) other.open = false; });
  }));
  document.addEventListener('click', e => { if (!e.target.closest('.nav-dropdown')) document.querySelectorAll('.nav-dropdown').forEach(el => el.open = false); });
  // Stock per variant (tracked variants only), kept fresh from the stock-map section
  const stockMap = {};
  const maxFor = id => (String(id) in stockMap ? Math.max(0, Math.min(99, Number(stockMap[String(id)]))) : 99);
  const loadStock = async () => {
    try {
      const res = await fetch('/?sections=stock-map', { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const found = /<script[^>]*data-stock-map[^>]*>([\s\S]*?)<\/script>/.exec(data['stock-map'] || '');
      if (!found) return;
      Object.keys(stockMap).forEach(key => delete stockMap[key]);
      Object.assign(stockMap, JSON.parse(found[1]));
    } catch (e) { /* keep what the page already knows */ }
  };
  // Product page: the quantity cannot go above what is in stock for the chosen size
  const applyProductLimit = () => {
    const select = document.getElementById('variant');
    const input = document.getElementById('product-quantity');
    if (!select || !input) return;
    const id = select.value;
    const tracked = String(id) in stockMap;
    const max = maxFor(id);
    input.max = String(max || 1);
    if (Number(input.value) > max && max > 0) input.value = String(max);
    const note = document.querySelector('[data-stock-note]');
    if (note) {
      const low = tracked && max > 0 && max <= 10;
      note.hidden = !(low || (tracked && max === 0));
      note.textContent = max === 0 ? 'Sold out' : (Number(input.value) >= max ? `Only ${max} available` : `Only ${max} left`);
    }
    const buy = document.querySelector('.product-buy .add-product');
    if (buy && tracked && max === 0) { buy.disabled = true; buy.textContent = 'Sold Out'; }
    syncSteppers();
  };
  // The minus button greys out at 1 and the plus button at the most that can be ordered
  const syncSteppers = () => document.querySelectorAll('.product-buy__quantity, .cart-qty').forEach(box => {
    const input = box.querySelector('input');
    const minus = box.querySelector('[data-quantity="-1"]');
    const plus = box.querySelector('[data-quantity="1"]');
    if (input && minus) minus.disabled = (Number(input.value) || 1) <= 1;
    if (input && plus) plus.disabled = (Number(input.value) || 1) >= (Number(input.max) || 99);
  });
  (() => {
    const select = document.getElementById('variant');
    if (select) [...select.options].forEach(option => { if (option.dataset.stock !== undefined && option.dataset.stock !== '') stockMap[option.value] = Number(option.dataset.stock); });
    applyProductLimit();
    syncSteppers();
    if (select) loadStock().then(applyProductLimit);
  })();
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-quantity]');
    if (!button) return;
    const input = button.parentElement.querySelector('input');
    input.value = Math.min(Number(input.max) || 99, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(button.dataset.quantity)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncSteppers();
    if (button.closest('.product-buy__quantity')) applyProductLimit();
  });
  document.addEventListener('change', e => {
    if (e.target.id !== 'variant') return;
    const option = e.target.selectedOptions[0];
    document.getElementById('product-price').textContent = option.dataset.price;
    const button = document.querySelector('.add-product');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold Out' : 'Add to Cart';
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    applyProductLimit();
  });
  let cartCurrency = 'INR';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  const node = (tag, text, className) => { const el = document.createElement(tag); if (text !== undefined) el.textContent = text; if (className) el.className = className; return el; };
  async function request(path, options = {}) {
    const response = await fetch(root + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart. Please try again.');
    return data;
  }
  // Welcome and welcome-back codes get the friendly line from Theme settings → Cart instead of the code itself
  function discountLabel(discount, currency) {
    const data = cartDialog?.dataset || {};
    const match = [[data.welcomePrefix, data.welcomeText], [data.backPrefix, data.backText]]
      .find(([prefix, text]) => prefix && text && String(discount.title).toUpperCase().startsWith(prefix.toUpperCase()));
    if (!match) return discount.title;
    const text = match[1];
    const amount = discount.value_type === 'percentage' ? `${parseFloat(discount.value)}%` : money(parseFloat(discount.value) * 100, currency);
    return text.replace('[percent]%', amount).replace('[percent]', amount.replace('%', ''));
  }
  function renderCart(cart) {
    cartCurrency = cart.currency;
    if (!cartContent) { document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count); return; }
    cartContent.replaceChildren();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    if (!cart.items.length) { cartContent.append(node('p', 'Your cart is empty.', 'empty')); const link = node('a', 'Continue Shopping', 'button'); link.href = root + 'collections/all'; cartContent.append(link); return; }
    cart.items.forEach(item => {
      const line = node('article', undefined, 'cart-line'); line.dataset.key = item.key; line.dataset.unit = item.final_price; line.dataset.variant = item.variant_id;
      if (item.image) { const image = node('img'); image.src = item.image; image.alt = item.product_title; image.width = 75; image.height = 90; line.append(image); } else line.append(node('div'));
      const details = node('div'); const heading = node('h2'); const link = node('a', item.product_title); link.href = item.url; heading.append(link); details.append(heading);
      if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', item.variant_title));
      const inputId = 'drawer-quantity-' + cart.items.indexOf(item); const label = node('label', 'Quantity'); label.htmlFor = inputId; details.append(label);
      const input = node('input'); input.id = inputId; input.type = 'number'; input.readOnly = true; input.min = '0'; input.max = String(Math.max(maxFor(item.variant_id), item.quantity)); input.value = item.quantity; input.setAttribute('aria-label', `Quantity for ${item.product_title}`);
      input.addEventListener('change', async () => {
        if (!input.checkValidity()) { input.reportValidity(); return; }
        await changeCart(item.key, Number(input.value));
      });
      const remove = node('button', undefined, 'cart-line__remove'); remove.type = 'button'; remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>'; remove.setAttribute('aria-label', `Remove ${item.product_title}`); remove.addEventListener('click', () => changeCart(item.key, 0));
      // − / + stepper around the quantity box
      const step = (text, change, label) => { const button = node('button', text); button.type = 'button'; button.id = `${inputId}-${change > 0 ? 'plus' : 'minus'}`; button.setAttribute('aria-label', `${label} quantity for ${item.product_title}`); button.addEventListener('click', () => changeCart(item.key, Math.max(0, item.quantity + change))); if (change < 0 && item.quantity <= 1) button.disabled = true; if (change > 0 && item.quantity >= maxFor(item.variant_id)) button.disabled = true; return button; };
      const stepper = node('div', undefined, 'cart-line__qty'); stepper.append(step('−', -1, 'Decrease'), input, step('+', 1, 'Increase'));
      const actions = node('div', undefined, 'cart-line__actions'); actions.append(stepper, remove);
      details.append(actions); if (item.quantity >= maxFor(item.variant_id)) details.append(node('p', 'Only ' + maxFor(item.variant_id) + ' available', 'cart-line__stock')); line.append(details, node('p', money(item.final_line_price, cart.currency), 'cart-line__price')); cartContent.append(line);
    });
    // Order discounts: subtotal, one line per discount, then the total
    // Shopify's change reply lists these as { amount, discount_application }; /cart.js lists the application itself
    const discounts = (cart.cart_level_discount_applications || []).map(d => (d.discount_application ? { ...d.discount_application, total_allocated_amount: d.amount } : d));
    if (discounts.length) {
      const before = node('p', undefined, 'cart-sum'); before.append(node('span', 'Subtotal'), node('span', money(cart.items_subtotal_price, cart.currency))); cartContent.append(before);
      discounts.forEach(discount => {
        const line = node('p', undefined, 'cart-discount');
        line.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>';
        line.append(node('span', discountLabel(discount, cart.currency)), node('strong', '−' + money(discount.total_allocated_amount, cart.currency))); cartContent.append(line);
      });
    }
    const subtotal = node('p', undefined, 'subtotal'); subtotal.append(node('span', discounts.length ? 'Total' : 'Subtotal'), node('strong', money(cart.total_price, cart.currency))); cartContent.append(subtotal, node('p', 'Taxes and shipping calculated at checkout.'));
    const checkout = node('form'); checkout.method = 'post'; checkout.action = root + 'cart'; const checkoutButton = node('button', 'Check Out', 'button'); checkoutButton.type = 'submit'; checkoutButton.name = 'checkout'; checkout.append(checkoutButton);
    const viewCart = node('a', 'View Cart', 'button outline'); viewCart.href = root + 'cart'; cartContent.append(viewCart, checkout);
  }
  async function changeCart(id, quantity) {
    if (cartBusy) return;
    const focusedId = document.activeElement?.id;
    cartBusy = true; cartContent.setAttribute('aria-busy', 'true');
    // Show the new quantity and line price straight away; the real cart replaces them when Shopify answers
    const row = [...cartContent.querySelectorAll('.cart-line')].find(el => el.dataset.key === id);
    if (row && quantity > maxFor(row.dataset.variant)) quantity = maxFor(row.dataset.variant);
    if (row && quantity > 0) { const qtyInput = row.querySelector('.cart-line__qty input'); if (qtyInput) qtyInput.value = quantity; const price = row.querySelector('.cart-line__price'); if (price) price.textContent = money(Number(row.dataset.unit) * quantity, cartCurrency); }
    cartContent.querySelectorAll('input,button').forEach(el => el.disabled = true);
    try { renderCart(await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity }) })); say('Cart updated.'); }
    catch (error) { const alert = node('p', error.message, 'form-error'); alert.setAttribute('role', 'alert'); cartContent.prepend(alert); cartContent.querySelectorAll('input,button').forEach(el => el.disabled = false); }
    finally { cartBusy = false; cartContent.removeAttribute('aria-busy'); if (focusedId || !cartDialog.contains(document.activeElement)) { const next = (focusedId && document.getElementById(focusedId)) || cartContent.querySelector('input,button,a') || cartDialog.querySelector('[data-close]'); next?.focus(); } }
  }
  const sizedImage = (src, width) => { try { const url = new URL(src, location.href); url.searchParams.set('width', width); return url.href; } catch { return src; } };
  function showNotice(item, count) {
    const product = document.getElementById('cart-notice-product');
    product.replaceChildren();
    if (item.image) { const frame = node('span', undefined, 'cart-notice__image'); const image = node('img'); image.src = sizedImage(item.image, 140); image.alt = item.product_title; image.width = 70; image.height = 70; frame.append(image); product.append(frame); }
    const details = node('div'); details.append(node('p', item.product_title, 'cart-notice__name'));
    if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', item.variant_title, 'cart-notice__variant'));
    product.append(details);
    const view = document.getElementById('cart-notice-view');
    if (view) view.textContent = count ? `${view.dataset.label} (${count})` : view.dataset.label;
    noticeFocus = document.activeElement;
    notice.classList.add('is-active');
    notice.focus({ preventScroll: true });
  }
  // Adding checks live stock, counting what is already in the cart
  async function checkStock(form) {
    const select = form.querySelector('select[name="id"]');
    const field = form.querySelector('[name="quantity"]');
    if (!select || !field) return;
    const [cart] = await Promise.all([request('cart.js'), loadStock()]);
    const id = select.value;
    const tracked = id in stockMap;
    if (!tracked) return;
    const inCart = cart.items.filter(item => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
    const room = maxFor(id) - inCart;
    if (Number(field.value) > room) throw new Error(room > 0 ? `Only ${room} more can be added (you already have ${inCart} in your cart).` : (maxFor(id) > 0 ? 'The most available is already in your cart.' : 'Sorry, this is sold out.'));
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    if (!window.fetch || !notice) return;
    e.preventDefault(); const button = form.querySelector('[type=submit]'); const original = button.textContent; button.disabled = true; button.textContent = 'Adding…';
    const errorElement = form.querySelector('.form-error'); if (errorElement) errorElement.hidden = true;
    try {
      await checkStock(form);
      const added = await request('cart/add.js', { method: 'POST', body: new FormData(form) });
      say('Item added to your cart.');
      let cart = null;
      try { cart = await request('cart.js'); renderCart(cart); } catch { /* the card still shows without the count */ }
      showNotice(added.items?.[0] || added, cart?.item_count);
    }
    catch (error) { if (errorElement) { errorElement.textContent = error.message; errorElement.hidden = false; } else { let message = form.querySelector('[role=alert]'); if (!message) { message = node('p', undefined, 'form-error'); message.setAttribute('role', 'alert'); form.append(message); } message.textContent = error.message; } }
    finally {
      const selected = form.querySelector('select[name="id"]')?.selectedOptions[0];
      button.disabled = selected ? selected.dataset.available !== 'true' : false;
      button.textContent = button.disabled ? 'Sold Out' : original;
    }
  });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-print]')) window.print();
  });
})();

// Product gallery: a thumbnail (or the variant picture chosen in Shopify admin) shows in the big image
document.addEventListener('DOMContentLoaded', () => {
  const thumbs = [...document.querySelectorAll('.thumb-item')];
  thumbs.forEach(thumb => thumb.addEventListener('click', e => {
    e.preventDefault();
    thumbs.forEach(item => item.classList.toggle('is-active', item === thumb));
    const display = document.getElementById('main-media-display');
    if (!display) return;
    const type = thumb.dataset.mediaType;
    if (type && type !== 'image') {
      // Video/3D media: reuse the tag already built for the mobile gallery instead of a plain image swap
      const slide = document.querySelector(`.product-swipe__slide[data-media-id="${thumb.dataset.mediaId}"]`);
      if (slide) { display.innerHTML = slide.innerHTML; return; }
    }
    const src = thumb.dataset.src;
    if (!src) return;
    let img = display.querySelector('img#main-product-image');
    if (!img) { display.innerHTML = '<img id="main-product-image" class="featured-img" alt="">'; img = display.querySelector('img'); }
    // Drop srcset/sizes so the browser loads exactly the chosen picture
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }));

  const container = document.querySelector('.thumbnails-slider-container');
  const track = container && container.querySelector('.gallery-thumbnails');
  if (track) {
    container.querySelector('.arrow-left')?.addEventListener('click', e => { e.preventDefault(); track.scrollBy({ left: -170, behavior: 'smooth' }); });
    container.querySelector('.arrow-right')?.addEventListener('click', e => { e.preventDefault(); track.scrollBy({ left: 170, behavior: 'smooth' }); });
  }
});// While the sign-up offer is switched off, drop any welcome discount a visitor still carries from before
(() => {
  if (!document.querySelector('[data-signup-off]')) return;
  const KEY = 'nl_welcome_discount_checked';
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
  fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count) { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
      if (!(cart.discount_codes || []).some(d => /^NECTAR-(WLC|WB)-/i.test(d.code))) return;
      // Keep any other code the customer entered themselves; only the welcome ones go
      const keep = (cart.discount_codes || []).filter(d => d.applicable && !/^NECTAR-(WLC|WB)-/i.test(d.code)).map(d => d.code);
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) })
        .then(() => { if (document.querySelector('[data-cart-page]')) location.reload(); });
    })
    .catch(() => {});
})();
